
const digest = '11d250176467a8624387356ac4e02849df2169ec42caafc28a122a7020106cb5';
const classes = {"wrapper":"_wrapper_1f2q8_1","date":"_date_1f2q8_9","decisionNumber":"_decisionNumber_1f2q8_13","row":"_row_1f2q8_17","diagnosis":"_diagnosis_1f2q8_24","status":"_status_1f2q8_34","bottomRow":"_bottomRow_1f2q8_41","duration":"_duration_1f2q8_45","active":"_active_1f2q8_55"};
const css = `._wrapper_1f2q8_1 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: #f7f8fa;
  padding: 18px;
  font-size: 14px;
}
._wrapper_1f2q8_1 ._date_1f2q8_9 {
  font-weight: 600;
  text-align: right;
}
._wrapper_1f2q8_1 ._decisionNumber_1f2q8_13 {
  font-weight: 600;
  letter-spacing: 0.2px;
}
._wrapper_1f2q8_1 ._row_1f2q8_17 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
._wrapper_1f2q8_1 ._diagnosis_1f2q8_24 {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #4a4b4f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}
._wrapper_1f2q8_1 ._status_1f2q8_34 {
  flex: 0 0 auto;
  font-size: 12px;
  color: #4a4b4f;
  white-space: nowrap;
  text-align: right;
}
._wrapper_1f2q8_1 ._bottomRow_1f2q8_41 {
  display: flex;
  justify-content: flex-end;
}
._wrapper_1f2q8_1 ._duration_1f2q8_45 {
  font-size: 12px;
  color: #667085;
  white-space: nowrap;
  text-align: right;
}
._wrapper_1f2q8_1:hover {
  cursor: pointer;
  background-color: #eff1f6;
}
._wrapper_1f2q8_1._active_1f2q8_55 {
  background-color: #eaeef9;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  